// Registra el Service Worker para soporte offline, y avisa cuando hay una
// versión nueva instalada y esperando (bug de producción: sin esto, un
// usuario podía quedar atrapado para siempre en una versión vieja de la app
// sin ninguna forma de darse cuenta ni de forzar la actualización).
// En desarrollo (CRA) los SW solo funcionan en https o localhost; el preview de Emergent usa https.

let updateCallback = null;
export function onSWUpdate(cb) {
  updateCallback = cb;
}

export function applySWUpdate() {
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg?.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
  });
}

export function registerSW() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        const notifyRefresh = () => {
          reg.active?.postMessage({ type: 'REFRESH_PRECACHE' });
          reg.update();
        };
        notifyRefresh();
        window.addEventListener('online', notifyRefresh);

        // Ya había una versión nueva esperando cuando se registró (ej. se
        // instaló en segundo plano mientras la pestaña estaba abierta).
        if (reg.waiting) updateCallback?.();

        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && reg.waiting) {
              updateCallback?.();
            }
          });
        });
      })
      .catch((err) => {
        console.warn('SW registration failed', err);
      });
  });
}
